import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _listCustomFieldSuggestionsRequest = {};
var _listCustomFieldSuggestionsResponse = {};
var _queryCustomFieldSuggestionsRequest = {};
var _queryCustomFieldSuggestionsResponse = {};
function resolveComWixpressMembersCustomfieldsSuggestionsCustomFieldSuggestionsUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/members-custom-fields-suggestions-api',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/members/v1/custom-field-suggestions',
                destPath: '/v1/custom-field-suggestions',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/members/v1/custom-field-suggestions',
                destPath: '/v1/custom-field-suggestions',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/members/v1/custom-field-suggestions',
                destPath: '/v1/custom-field-suggestions',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Returns suggestions of custom fields to add. */
export function listCustomFieldSuggestions(payload) {
    var _a = serializer(_listCustomFieldSuggestionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listCustomFieldSuggestionsResponse, {}).fromJSON;
    function __listCustomFieldSuggestions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.custom_field_suggestion',
            method: 'GET',
            methodFqn: 'com.wixpress.members.customfields.suggestions.CustomFieldSuggestions.ListCustomFieldSuggestions',
            url: resolveComWixpressMembersCustomfieldsSuggestionsCustomFieldSuggestionsUrl({
                protoPath: '/v1/custom-field-suggestions',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listCustomFieldSuggestions.fromReq = fromReq;
    __listCustomFieldSuggestions.__isAmbassador = true;
    return __listCustomFieldSuggestions;
}
/** Returns suggestions of custom fields to add by specified type. */
export function queryCustomFieldSuggestions(payload) {
    var _a = serializer(_queryCustomFieldSuggestionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryCustomFieldSuggestionsResponse, {}).fromJSON;
    function __queryCustomFieldSuggestions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.custom_field_suggestion',
            method: 'POST',
            methodFqn: 'com.wixpress.members.customfields.suggestions.CustomFieldSuggestions.QueryCustomFieldSuggestions',
            url: resolveComWixpressMembersCustomfieldsSuggestionsCustomFieldSuggestionsUrl({
                protoPath: '/v1/custom-field-suggestions/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryCustomFieldSuggestions.fromReq = fromReq;
    __queryCustomFieldSuggestions.__isAmbassador = true;
    return __queryCustomFieldSuggestions;
}
//# sourceMappingURL=http.impl.js.map